// ============================================================
// หน้า RecordBill — ออกใบแจ้งหนี้อื่นๆ
// ------------------------------------------------------------
// ใช้ออกใบแจ้งหนี้รายการเดียวที่ไม่ใช่ค่าน้ำ/ค่าส่วนกลางประจำเดือน
// (เช่น ค่าซ่อมแซม ค่าปรับ ฯลฯ)
//
// ขั้นตอน
//   1. เลือกบ้านเลขที่ → ระบบเติมชื่อ/หน่วยงาน/ที่อยู่ให้ (พิมพ์แก้เองได้)
//   2. กรอกรายการและราคา
//   3. กด "พิมพ์ใบเสร็จ" → บันทึกลงระบบ แล้วเปิดหน้าเอกสารในแท็บใหม่ พร้อมล้างฟอร์มเพื่อออกใบถัดไป
//
// เลขที่ใบแจ้งหนี้ (iw_number) สร้างจากเวลาปัจจุบัน รูปแบบ ปปดดวว + ชม.นาที.วินาที
// ============================================================

import React, { Component } from "react";
import Select from "react-select";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar.js";
import { tokens, alert, select_style, toFixed, GET, POST, format_date, float, validate, DatePicker, NumberZero, getStorage, loading, permission, openDocument, buildInvoiceOtherData } from "../../shared/index.js";

// หน้านี้ใช้สิทธิ์เดียวกับเมนู "บันทึกรายรับอื่นๆ"
const perm = permission("record-other");

export default class RecordBill extends Component {
  constructor(props) {
    super(props);
    // data_manage (master รายการ) อยู่นอก getInitialState เพื่อไม่ให้ถูกล้างตอน reset ฟอร์มหลังบันทึก
    this.state = { ...this.getInitialState(), data_manage: [] };
  }

  // ค่าเริ่มต้นของฟอร์ม (ใช้ทั้งตอนเปิดหน้าและตอนล้างฟอร์มหลังบันทึก)
  getInitialState = () => {
    const now = new Date();
    return {
      data_customer: [], // ตัวเลือกบ้านเลขที่
      customer_id: "",
      address_number: null, // option ที่เลือกอยู่
      record_date: now,
      record_time: `${NumberZero(now.getHours())}:${NumberZero(now.getMinutes())}`,
      // เลขที่ใบแจ้งหนี้จากเวลาปัจจุบัน (ตัด : ออก)
      iw_number: format_date(now, "yymmddhh:mm:ss").replace(/:/g, ""),
      // ข้อมูลผู้รับใบแจ้งหนี้
      full_name: "",
      project_name: "",
      address: "",
      // รายการที่เรียกเก็บ
      code: "",
      title: "",
      description: "",
      cost: "",
      total_amount: 0.0,
      // ข้อมูลผู้ลงนามในเอกสาร (จากตั้งค่าเอกสารใบเสร็จ)
      receipt_id: "",
      remark: "",
      full_name_print: "",
      position_name: "",
    };
  };

  async componentDidMount() {
    loading(false);
    if (!perm.view) return;
    loading(true);
    await Promise.all([this.GetPDFReceipt(), this.GetCustomerAll(), this.GetInvoiceItemAll()]);
    loading(false);
  }

  // ---------- โหลดข้อมูล ----------

  // ตัวเลือกบ้านเลขที่ (แสดงเป็น "อาคาร x ห้อง y")
  GetCustomerAll = async () => {
    const res = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (res?.status) {
      this.setState({ data_customer: res.data.data.map((item) => ({ ...item, value: item.customer_id, label: `อาคาร ${item.building} ห้อง ${item.address_number}` })) });
    }
  };

  // master รายการออกใบแจ้งหนี้ (ตัวเลือกช่อง "รายการ")
  GetInvoiceItemAll = async () => {
    const res = await GET(tokens, "v1/TH/document-manage/invoice-item-list/filter-search/page/0", { data_search: "" });
    if (res?.status) this.setState({ data_manage: res.data.data });
  };

  // ตั้งค่าเอกสารใบเสร็จ (ผู้ลงนาม/หมายเหตุท้ายเอกสาร)
  GetPDFReceipt = async () => {
    const res = await GET(tokens, `v1/TH/document-manage/detail/receipt/${getStorage("receipt_id")}`);
    if (res?.status) {
      const { receipt_id, remark, full_name, position_name } = res.data.data;
      this.setState({ receipt_id, remark, full_name_print: full_name, position_name });
    }
  };

  // ---------- บันทึก ----------

  Create = async () => {
    loading(true);
    const { record_date, record_time, iw_number, full_name, project_name, address, code, title, description, cost, total_amount, address_number } = this.state;

    const payload = {
      record_date: new Date(record_date).toISOString().split("T")[0],
      record_time,
      iw_number,
      full_name,
      agency_name: project_name,
      address_number: address,
      record_other_list: [{ code, title, description, cost: Number(cost) }],
      total_amount,
    };

    const res = await POST(tokens, `v1/TH/record-other/create/${getStorage("project_id")}`, payload);

    if (res?.status) {
      // NOTE alert() รับแค่ 3 พารามิเตอร์ ตัวที่ 4 ("/record-other") ไม่มีผล
      // จึงไม่ได้เด้งไปหน้าอื่น — เป็นพฤติกรรมเดิม ถ้าต้องการให้เด้งจริงต้องเปลี่ยนเป็น alert_url
      alert("success", "สำเร็จ", `บันทึกใบแจ้งหนี้หมายเลข "${iw_number}" สำเร็จแล้ว`, "/record-other");

      // เปิดหน้าเอกสารใบแจ้งหนี้อื่น ๆ ในแท็บใหม่
      openDocument(
        "/doc/invoice-other",
        buildInvoiceOtherData({
          full_name,
          address: address || address_number?.address_number,
          iw_number,
          record_date,
          title,
          description,
          cost,
        })
      );

      // ล้างฟอร์มให้ออกใบถัดไปได้ทันที
      this.setState(this.getInitialState());
    }
    loading(false);
  };

  // เลือกบ้านเลขที่ → เติมข้อมูลผู้รับใบแจ้งหนี้ให้อัตโนมัติ
  onSelectCustomer = (option) => {
    this.setState({
      customer_id: option.customer_id,
      full_name: option.full_name,
      project_name: option.project_name,
      address: option.address || option.address_number,
      address_number: option,
    });
  };

  // พิมพ์แก้ข้อมูลผู้รับเอง = ถือว่าไม่ได้ผูกกับบ้านเลขที่ที่เลือกไว้แล้ว
  handleTextChange = (field) => (e) => this.setState({ [field]: e.target.value, customer_id: "", address_number: null });

  render() {
    const { iw_number, data_customer, address_number, record_date, record_time, full_name, project_name, address, code, title, description, cost, total_amount, data_manage } = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ออกใบแจ้งหนี้อื่นๆ" />
        <div className="body">
          <div className="p-3">
            {/* หัวข้อ + ปุ่มไปหน้ารายการทั้งหมด */}
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h4 className="mb-0">
                <b>ออกใบแจ้งหนี้อื่นๆ เลขที่ใบแจ้งหนี้ : {iw_number || "-"}</b>
              </h4>
              <button className="btn btn-outline-primary px-4 mx-1" onClick={() => (window.location.href = "/record-bill-history")}>
                รายการทั้งหมด
              </button>
            </div>

            {/* ข้อมูลผู้รับใบแจ้งหนี้ */}
            <div className="card border-0 px-3 pt-3 mb-3">
              <div className="row">
                <div className="col-12 col-lg-4 col-xl-3 mb-3">
                  <label>บ้านเลขที่</label>
                  <Select className="bg-contain border-0 select-search w-100" styles={select_style} options={data_customer} value={address_number} onChange={this.onSelectCustomer} />
                </div>
                {/* วันที่/เวลา ล็อกไว้เป็นเวลาที่เปิดหน้า แก้ไม่ได้ */}
                <div className="col-6 col-md-4 mb-3">
                  <label>วันที่</label>
                  <DatePicker className="form-control bg-contain border-0" value={record_date} disabled />
                </div>
                <div className="col-6 col-md-4 mb-3">
                  <label>เวลา</label>
                  <input type="time" className="form-control bg-contain border-0" value={record_time} disabled />
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <label>ชื่อ-นามสกุล</label>
                  <input type="text" className="form-control bg-contain border-0" value={full_name} onChange={this.handleTextChange("full_name")} />
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <label>ชื่อหน่วยงาน</label>
                  <input type="text" className="form-control bg-contain border-0" value={project_name} onChange={this.handleTextChange("project_name")} />
                </div>
                <div className="col-12 col-md-4 mb-3">
                  <label>ที่อยู่</label>
                  <input type="text" className="form-control bg-contain border-0" value={address} onChange={this.handleTextChange("address")} />
                </div>
              </div>
            </div>

            {/* รายการที่เรียกเก็บ (ออกได้ครั้งละ 1 รายการ) */}
            <div className="card border-0 p-3 mb-3">
              <table className="table table-borderless table-striped mb-0">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    <th className="text-center wpx-120">ลำดับที่</th><th className="text-center">รายการ</th><th className="text-center">รายละเอียด</th>
                    <th className="text-right wpx-200">ราคารวมสุทธิ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Select className="form-control border-0 select-search w-100" styles={select_style} options={(data_manage || []).map((d) => ({ value: d.title, label: d.code }))} value={code ? { value: title, label: code } : null} onChange={(e) => this.setState({ code: e.label, title: e.value })} />
                    </td>
                    <td>
                      <input type="text" className="form-control" value={title} readOnly />
                    </td>
                    <td>
                      <textarea className="form-control" placeholder="รายละเอียด" onChange={(e) => this.setState({ description: e.target.value })} value={description} maxLength={2000} />
                    </td>
                    <td>
                      <input type="text" className="form-control" value={cost} maxLength={11} onChange={(e) => float(e.target.value) && this.setState({ cost: e.target.value, total_amount: Number(e.target.value) })} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="card border-0 p-3 mb-3 d-flex flex-row justify-content-between">
              <b>จัดเก็บเงินทั้งสิ้น</b> <b>฿{toFixed(total_amount)}</b>
            </div>

            {perm.create && (
              <button className="btn btn-outline-primary bg-white w-100 mb-4" onClick={() => !validate(this.state, ["full_name", "project_name", "address", "title", "cost"]) && this.Create()}>
                พิมพ์ใบเสร็จ
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
